module.exports = __webpack_public_path__ + "static/media/me3_logo_black_NEW.583dfa7c.png";